import React, { useMemo, useState } from 'react';
import {
  Switch,
} from '@/components/DesignLibrary/Atoms';
import { useFormEditorContext } from '@/components/Questionnaire/questionnaireEditor/FormEditor/FormEditorContext';
import Expression from '@/helpers/expressions/ThisExpression';
import ExpressionEditor from '@/components/ExpressionEditor';
import { Questionnaire } from '@/typings/Questionnaire';
import makeDefaultExpression from '@/helpers/makeDefaultExpression';

type ConditionsProps = {
  disabled?: boolean;
  conditionExpression?: Expression;
  setConditionExpression?: Parameters<typeof ExpressionEditor>[0]['onChange'];
};

const Conditions: React.FC<ConditionsProps> = ({
  disabled,
  conditionExpression,
  setConditionExpression,
}) => {
  const { formData } = useFormEditorContext();
  const [showConditions, setShowConditions] = useState(
    Boolean(conditionExpression?.expression),
  );

  const fieldsInfo = useMemo(() => {

    const info: Record<
      string,
      Pick<Questionnaire.FieldCommon, 'key' | 'label' | 'type' | 'options'>
    > = {};

    formData.sections.forEach((section) => {
      section.fields.forEach((field) => {
        info[field.key] = {
          key: field.key,
          label: field.label || field.key,
          options: field.options,
          type: field.type,
        };
      });
    });

    return info;
  }, [formData.sections]);

  return (
    <>
      <Switch
        disabled={disabled}
        label="Show conditionally"
        name="show-conditions"
        isChecked={showConditions}
        onChange={(checked) => {
          setShowConditions(checked);
          if (!checked) {
            setConditionExpression?.(makeDefaultExpression());
          }
        }}
      />
      {showConditions && (
        <ExpressionEditor
          canEditVars={true}
          expression={conditionExpression ?? null}
          onChange={setConditionExpression}
          fieldsInfo={fieldsInfo}
        />
      )}
    </>
  );
};

export default Conditions;
